import LectureLessonHistoryListModelBase from '../_generated/modelBases/lecture-lesson-history-list-model-base';

export default class LectureLessonHistoryListModel extends LectureLessonHistoryListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
